import { api } from "core/axios/axios";

export async function getDashboardRes(filterVal = null) {
    if (filterVal !== null && filterVal?.startTime) {
        return api.get(
            `dashboard?startTime=${
                filterVal.startTime
            }&endTime=${new Date().toISOString()}`,
        );
    } else return api.get("dashboard");
}




export async function  getCampaignsStatsRes(cid: any, paginator: any) {
    return api.get(
        `campaigns/stats?cid=${cid}&paginator=${paginator}`,
    ).then((res) => res.data);
}